<template>
  <div class="col mx-auto">
    <div class="row align-content-center" style="min-height: 350px;" v-if="pageLoadReady && hasNoTasks">
      <div class="col-12 mx-auto text-center">
        <img src="/images/EmptyState.svg" alt="No Assigned Tasks">
      </div>
      <div class="col-12 mx-auto text-center mt-3">
        <div class="empty-state-title">No Task Yet</div>
        <p class="empty-state-description">We are searching for the right task for you, please come back
          later </p>
      </div>
    </div>

    <div class="row mt-4" style="min-height: 350px;" v-else>
      <div class="col-12 mx-auto p-0">
        <task-item v-for="(task, key) in tasks"
                   :isPersonal="true"
                   :key="key"
                   :task="task"
                   :viewOnly="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Task from '../../../Task/Task';

export default {
  data () {
    return {
      tasks: [],
      pageLoadReady: false,
      localShowGuide: true,
      taskService: Task,
    };
  },

  computed: {
    showGuide () {
      return !localStorage.getItem('wfh-show_task_guide') && this.localShowGuide && this.hasNoTasks;
    },

    hasNoTasks () {
      return this.pageLoadReady && this.tasks.length === 0;
    },
  },

  methods: {
    toggleCheckbox (taskKey) {
      this.tasks = this.tasks.map((task, key) => {
        return key === taskKey ? {
          ...task,
          completed_at: !task.completed_at,
        } : task;
      });
    },

    async fetchUserTasks () {
      const filters = {
        assigned_to: 'personal',
        type: 'todo',
        range: '7',
        status: 'pending_approval',
        per_page: 200,
        for_external: true,
      };

      const res = await this.taskService.fetchTasks(filters);

      this.tasks = res.data;
      this.pageLoadReady = true;
    },

    isCompleted (task) {
      return !!task.completed_at;
    },
  },

  mounted () {
    this.fetchUserTasks();
  },
};
</script>

<style scoped>

</style>
